<template>
    <label :for="id">
        <p>{{ title }}</p>
        <input v-if="type != 'select'" :type="type" :id="id" :value="modelRef" @input="inputFunc" :maxlength="max != undefined ? max : 2000" :min="min != undefined ? 0 : false">
        <select v-else :id="id" :value="modelRef" @input="inputFunc">
            <option disabled selected value class="defaultopt">Selecione uma opção</option>
            <option v-for="(opt, idx) in optList" :key="idx" :value="useIdx == true ? idx : opt[`${optValue}`]">{{ opt[`${optDisplay}`][0].toUpperCase() + opt[`${optDisplay}`].slice(1) }}
            </option>
        </select>
    </label>
</template>
<script>
export default {
    name: 'CustomInput',
    props: ['id', 'type', 'title', 'modelRef', 'inputFunc', 'optList', 'optValue', 'optDisplay', 'useIdx', 'max', 'min']
}
</script>
<style scoped>

label {
    width: 100%;
    position: relative;
    margin: 1rem 0;
}

label p {
    position: absolute;
    top: -.8rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.8rem;
    color:#FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
}

label input,
label select {
    width: 100%;
    padding: 0.7rem 0.5rem;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
}

.defaultopt{
    color: #999999;
}
</style>